import script from "./ShowMoreButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowMoreButton.vue?vue&type=script&setup=true&lang=ts"

import "./ShowMoreButton.vue?vue&type=style&index=0&id=0e286cab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e286cab"]])

export default __exports__